"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckmarkIcon = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const appear = (0, styled_components_1.keyframes) `
  from {
    transform: scale(0);
    opacity: 0;
  } to {
    transform: scale(1);
    opacity: 1;
  }
`;
exports.StyledCheckmarkIcon = styled_components_1.default.div `
  ${({ size }) => {
    return (0, styled_components_1.css) `
      width: ${size};
      height: ${size};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${theme_1.system.success};
      animation: ${appear} 0.2s ease;
      animation-fill-mode: forwards;

      > svg {
        animation: ${appear} 0.4s ease-in-out;
      }
    `;
}}
`;
//# sourceMappingURL=styles.js.map